import React from 'react';
import IntakeForm from './pages/IntakeForm';
export function App() {
  return <IntakeForm data-id="element-0" data-mp="35cc04n0rsbbh" />;
}